import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import './index.scss';
import { useIntl } from 'umi';
import DOMPurify from 'dompurify';
//  text 展开折叠值
//  otherText 按钮值， 默认展开关闭
//  otherText 按钮其他值
//  offsetHeight < scrollHeight || offsetWidth < scrollWidth 判断超出显示，不超出不显示
const DboExpandCollapseText = (porps: any) => {
  let { text, otherText, isShow, className, rowNum, noHtml } = porps;
  let TextDom = useRef(null);
  const { formatMessage } = useIntl();
  const [isShowFlag, setIsShow] = useState(isShow ? isShow : false);
  const [offsetHeight, setOffsetHeight] = useState(0);
  const [scrollHeight, setscrollHeight] = useState(0);
  const [windowSize, setWindowSize] = useState<any>(null);
  useEffect(() => {
    const func = () => setWindowSize(window.innerWidth);
    window.addEventListener('resize', func);
    return () => {
      window.removeEventListener('resize', func);
    };
  }, []);
  // 因为有响应式,所以要监听屏幕宽度，重新判断高度, 监听isShowFlag
  useLayoutEffect(() => {
    setOffsetHeight(TextDom?.current?.offsetHeight);
    setscrollHeight(TextDom?.current?.scrollHeight);
  }, [windowSize, isShowFlag]);

  return (
    <div
      className={`${className} dbo-expand-collapse-wrapper ${
        isShowFlag ? 'show' : 'hide'
      }`}
      style={{ WebkitLineClamp: rowNum ? rowNum : 2 }}
    >
      <div className="dbo-expand-collapse">
        <div className={`dbo-expand-collapse-text`} ref={TextDom} id="TextDom">
          {scrollHeight > offsetHeight ? (
            <label
              className="dbo-expand-collapse-text-btn"
              htmlFor="exp"
              onClick={(e) => {
                e.stopPropagation();
                setIsShow(!isShowFlag);
              }}
            >
              {otherText
                ? otherText
                : formatMessage({ id: isShowFlag ? 'Less' : 'More' })}
            </label>
          ) : isShowFlag ? (
            <label
              className="dbo-expand-collapse-text-btn"
              htmlFor="exp"
              onClick={(e) => {
                e.stopPropagation();
                setIsShow(!isShowFlag);
              }}
            >
              {formatMessage({ id: 'Less' })}
            </label>
          ) : null}
          {noHtml ? (
            <span className="dbo-expand-collapse-context">{text}</span>
          ) : (
            <span
              className="dbo-expand-collapse-context"
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }}
            ></span>
          )}
        </div>
      </div>
    </div>
  );
};

export default DboExpandCollapseText;
